import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./NoAiDataContainer.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { PlusIcon } from "@/frontend/shared/assets/icons";

export function NoAiDataContainer({
  section,
  onAddDataClick,
  name
}: {
  section: string;
  onAddDataClick?: () => void;
  name: string;
}) {
  return (
    <div className={styles.innoveraWhiteBlock}>
      <div className={styles.container}>
        <Typography variant="body-2" color="greyscale700" className={styles.description}>
          {name || "Company"} hasn’t provided any
          <span className={styles.sectionName}> {section} </span>
          data.
          {/* <br />
          Request data from the founder. */}
        </Typography>

        {!!onAddDataClick && (
          <NormalButton className={styles.requestButton} size="large" variant="secondary" onClick={onAddDataClick}>
            <PlusIcon />
            Add {section}
          </NormalButton>
        )}
      </div>
    </div>
  );
}
